module.exports = __webpack_public_path__ + "static/media/Recommended.eb9de076.gif";